import template from './single_score_slot.html'
import './single_score_slot.css'

export default {
  template,
  controller: 'singleScoreSlotController as singleScoreSlot',
  bindings: { data: '=', position: '=' }
}
